import {
  FormControlLabel as NovaBaseFormControlLabel,
  FormControlLabelProps as NovaFormControlLabelProps,
} from '@fme-nova/components'
import {
  default as MuiBaseFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps,
} from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import React from 'react'

import { createComponentWrapperWithRef, styled, uiTokens } from '../../theme'
import { COLORS } from '../../theme/colors'
import { computeStatusPropsFromOptionItem, OptionItem } from '../../utils'
import { Status } from '../Status'
import { Checkbox } from './Checkbox'

type FormControlLabelProps = Omit<MuiFormControlLabelProps & NovaFormControlLabelProps, 'ref'>

const MuiFormControlLabel = styled(MuiBaseFormControlLabel)`
  color: ${COLORS.text.primary};
  &:disabled {
    color: ${COLORS.text.disabled};
  }
`

const NovaFormControlLabel = styled(NovaBaseFormControlLabel)`
  color: ${uiTokens.uiContent.neutral};
  margin-left: -8px;
  &:disabled {
    color: ${COLORS.text.disabled};
  }
`
export const FormControlLabel = createComponentWrapperWithRef<FormControlLabelProps>(
  {
    mui: MuiFormControlLabel,
    nova: NovaFormControlLabel,
  },
  'CheckBoxFormControlLabel',
)

export function CheckBoxGroup(props: {
  options: OptionItem[]
  value: OptionItem[]
  onChange: (value: string | string[]) => void
  disabled?: boolean
}) {
  function handleChange(opt: OptionItem, checked: boolean) {
    let els = [...props.value]
    if (checked) {
      els.push(opt)
    } else {
      els = els.filter((e) => e.value != opt.value)
    }
    props.onChange(els.map((e) => e.value))
  }

  function checkValue(e: OptionItem): boolean {
    const r = props.value.findIndex((el) => el.value === e.value)
    return r !== -1
  }

  return (
    <>
      <FormGroup row data-test-id="checkbox-group">
        {props.options.map((e, i) => {
          const statusProps = computeStatusPropsFromOptionItem({ fontColor: e.color, icon: e.icon })

          return (
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  data-test-id="checkbox-group-item"
                  checked={checkValue(e)}
                  onChange={(_, checked) => handleChange(e, checked)}
                />
              }
              label={<Status {...statusProps}>{e.label}</Status>}
              disabled={props.disabled}
            />
          )
        })}
      </FormGroup>
    </>
  )
}
